import { API_ENDPOINTS } from '../endpoints';
import { gatewayUrlClient } from '../interceptor';

export const userAssignedCities = async(): Promise<string[]> => {
  const { data } = await gatewayUrlClient.get(
    API_ENDPOINTS.userAssignedCities
  )
  return data.data ?? [];
}
